import React from 'react'
import { useDrop } from 'react-dnd'

import type { DND_TYPES_ACCEPT, DragItemType } from '../constant'

import { ActionsDropZoneItem } from './ActionsDropZone/ActionsDropZone'

const handleDropCollect = monitor => {
  return {
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver({ shallow: true })
  }
}

type Props = {
  accept: DND_TYPES_ACCEPT
  children: React.ReactNode
  className?: string
  onDrop: (item: DragItemType) => void
  vertical?: boolean
}

type Collect = { isOver: boolean; canDrop: boolean }

const DropItem = React.memo<Props>(
  ({ children, vertical, className, onDrop, accept }) => {
    const [{ isOver }, drop] = useDrop<DragItemType, void, Collect>({
      accept,
      drop(item) {
        onDrop(item)
      },
      collect: handleDropCollect
    })

    const divRef = React.useRef<HTMLDivElement>(null)
    const combinedRef = React.useCallback(
      (node: HTMLDivElement) => {
        divRef.current = node
        drop(node)
      },
      [drop]
    )

    return (
      <ActionsDropZoneItem
        className={className}
        highlight={isOver}
        ref={combinedRef}
        vertical={vertical}
      >
        {children}
      </ActionsDropZoneItem>
    )
  }
)

export default DropItem
